import { render, staticRenderFns } from "./PagesWidgetPicker.vue?vue&type=template&id=b8b9a5d2&"
import script from "./PagesWidgetPicker.vue?vue&type=script&lang=js&"
export * from "./PagesWidgetPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports